import React, { useState } from 'react'

import List from '../../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'
import { ROUTE_NAME as IncidentTypesRouteName } from '../../../incidentTypes/constants'

import styles from './List.module.css'

const IncidentTypeList = () => {
  const [typeId, setTypeId] = useState(null)

  const typeColumns = [
    {
      header: 'Name',
      value: (item) => item.name,
      onClick: (item) => setTypeId(item.id),
    },
    { header: 'Code', value: (item) => item.code },
    { header: 'Buffers', value: (item) => item.buffers },
  ]

  const bufferColumns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'Type',
      value: (item) => `${item.incidentType.name} (${item.incidentType.code})`,
      isLink: true,
    },
    { header: 'AI Layer', value: (item) => item.aiLayer.name },
    { header: 'Distance', value: (item) => item.distance },
    { header: 'Unit', value: (item) => item.unit },
  ]

  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <List
          title="Incident Types"
          routeName={IncidentTypesRouteName}
          apiUrl={API_URL}
          columns={typeColumns}
        />
      </div>
      <div className={styles.column}>
        {typeId && (
          <List
            title="Buffers"
            routeName={ROUTE_NAME}
            apiUrl={`${API_URL}/byType/${typeId}`}
            columns={bufferColumns}
          />
        )}
      </div>
    </div>
  )
}

export default IncidentTypeList
